/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TextImageContent } from '../../models/text-image-content';

export interface ApiMasterTextImageContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterTextImageContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterTextImageContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TextImageContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTextImageContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TextImageContent>;
    })
  );
}

apiMasterTextImageContentGetByIdGet.PATH = '/api/Master/TextImageContent/GetById';
